import { render, staticRenderFns } from "./CompanySelect.vue?vue&type=template&id=2b0a084b&scoped=true&"
import script from "./CompanySelect.vue?vue&type=script&lang=js&"
export * from "./CompanySelect.vue?vue&type=script&lang=js&"
import style0 from "./CompanySelect.vue?vue&type=style&index=0&id=2b0a084b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a084b",
  null
  
)

export default component.exports